export default {
  name: 'contactName',
  title: 'contactTitle',
  phoneNumber: 'contactPhoneNumber',
  backupPhoneNumber: 'contactBackupPhoneNumber',
};



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/StoreContactsModal/constants.js